<template>
    <div>
        <div class="map">
            <div class="wrap mapImg">
                <div style="width: 350px;flex-shrink: 0;">
                    <div class="name">{{title}}</div>
                    <!-- <div class="email">cctvisgiw@163.com</div>
                    <div class="tel">+7(466)888-666-444</div>
                    <div class="address">
                        9 Lesnaya Street, White Garden, Block B, 6th Floor
                    </div> -->
                    <div v-html="content">

                    </div>
                </div>
                <div style="text-align: right;width: 850px;flex-shrink: 0;"><img :src="backImg" alt="" style="width: 850px;height: 325px;"></div>
            </div>
        </div>
        <div class="pl"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:'',
            content:'',
            backImg:''
        }
    },
    created(){
        this.$http.getContact().then((res)=>{
            if(Object.keys(res).length!=0){
                this.title=res.config['Single-singlepage-other'][0].title
                this.content=res.config['Single-singlepage-other'][0].content
                this.backImg=res.config['Single-singlepage-other'][0].mainpic_fullpath
            }
            
        })
    }
}
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
.map {
    height: 325px;
    // margin-top: 115px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background: #f7f7f7;
    .mapImg{
        display: flex;
    }
    .name {
        font-size: 34px;
        font-weight: bold;
        padding: 47px 0 60px 0;
    }
    /deep/.email{
        margin-bottom: 25px;
        font-size: 14px;
        color: #666666;
    }
    /deep/.tel {
        margin-bottom: 25px;
        font-size: 14px;
        color: #666666;
    }
    /deep/.address {
        color: #333333;
        font-size: 16px;
    }
}
</style>